export const STORAGE_NON_CD_LOCATIONS = ["STO_AMP", "STO_COL_MCI"];
